import * as customersActions from '../actions/customers.actions';
import { CustomerApiModel } from 'app/models/customer-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  customers: CustomerApiModel[];
  isLoading: boolean;
  isReady: boolean;
  totalCustomers: number;
  isSaving: boolean;
}

export const initialState: State = {
  customers: [],
  isLoading: false,
  isReady: false,
  totalCustomers: 0,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(customersActions.loadCustomers, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(customersActions.loadCustomersSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    customers: response.results,
    totalCustomers: response.count,
  })),
  on(
    customersActions.createCustomer,
    customersActions.updateCustomer,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    customersActions.createCustomerSuccess,
    customersActions.createCustomerFailed,
    customersActions.updateCustomerSuccess,
    customersActions.updateCustomerFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    customersActions.resetCustomers,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
